import type { StorageValue, StorageProperties } from "./storage-type";

export const clear = (): void => {
  const cookies: string[] = document.cookie.split(";");

  for (const cookie of cookies) {
    const key: string | undefined = cookie.trim().split("=", 1)[0];
    if (key) {
      remove(key);
    }
  }
};
export const get = (key: string): string | null => {
  const cookies = document.cookie.split(";");
  const cookie = cookies.find((c) => c.trim().startsWith(`${key}=`));

  if (!cookie) {
    return null;
  }

  return decodeURIComponent(cookie.trim().slice(Math.max(0, key.length + 1)));
};
export const has = (key: string): boolean => get(key) !== null;
export const keys = (): string[] => {
  const cookies = document.cookie.split(";");
  const keys: string[] = [];

  for (const cookie of cookies) {
    const key: string | undefined = cookie.trim().split("=", 1)[0];
    if (key) {
      keys.push(key);
    }
  }

  return keys;
};
export const remove = (key: string): void => {
  set(key, "", { expires: -1, path: "/" });
};
export const set = (
  key: string,
  value: StorageValue,
  properties?: StorageProperties,
): void => {
  const serializedValue =
    typeof value === "object" ? JSON.stringify(value) : String(value);
  let item = `${key}=${encodeURIComponent(serializedValue)}`;

  item += properties?.expires ? `; expires=${String(properties.expires)}` : "";
  item += properties?.secure ? `; Secure` : "";
  item += properties?.httpOnly ? `; HttpOnly` : "";
  item += properties?.domain ? `; Domain=${properties.domain}` : "";
  item += properties?.path ? `; Path=${properties.path}` : `; Path=/`;
  item += properties?.sameSite ? `; SameSite=${properties.sameSite}` : "";

  document.cookie = item;
};
export const update = (key: string, value: StorageValue): void => {
  if (has(key)) {
    set(key, value);
  }
};
